import {toast} from 'react-toastify'
const options = {
//   position: toast.POSITION.TOP_CENTER,
  className: 'toasterClass'
   
};

export default options